import { render, staticRenderFns } from "./social-login.vue?vue&type=template&id=0bf1d26e&"
import script from "./social-login.vue?vue&type=script&lang=js&"
export * from "./social-login.vue?vue&type=script&lang=js&"
import style0 from "./social-login.vue?vue&type=style&index=0&id=0bf1d26e&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports